import { render } from "./HaircolorTreatTip.vue?vue&type=template&id=6953188c"
import script from "./HaircolorTreatTip.vue?vue&type=script&lang=js"
export * from "./HaircolorTreatTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__